class AnnouncementSidebarComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    var arrowPath = 'M37.0607 13.0607C37.6464 12.4749 37.6464 11.5251 37.0607 10.9393L27.5147 1.39339C26.9289 0.807608 25.9792 0.807608 25.3934 1.3934C24.8076 1.97918 24.8076 2.92893 25.3934 3.51472L33.8787 12L25.3934 20.4853C24.8076 21.0711 24.8076 22.0208 25.3934 22.6066C25.9792 23.1924 26.9289 23.1924 27.5147 22.6066L37.0607 13.0607ZM9.26192e-08 13.5L36 13.5L36 10.5L-9.26192e-08 10.5L9.26192e-08 13.5Z';

    var textSplide = new Splide(this.querySelector('.text-carousel'), {
      type: 'loop',
      arrowPath: arrowPath,
      autoplay: true,
      speed: 1000
    });
    textSplide.mount();
  }
}

customElements.define('announcement-slider-component', AnnouncementSidebarComponent);